import { ApolloLink, ServerError, ServerParseError } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { AppErrorBuilder } from '@h5s/util-error';
import { LoggerService } from '@h5s/util-logger';
import { ErrorService } from './error.service';
import { safeStringify } from '@h5s/util-string';

export function apolloNetworkErrorInterceptor(loggerService: LoggerService, errorService: ErrorService): ApolloLink {
  return new ErrorLink(({ error, operation }) => {
    // ASSERTION: Non sono presenti errori, allora non facciamo nulla
    if (!error) return;

    const logger = loggerService.getLogger('networkErrorLink');

    // Sono presenti errori di rete
    if (ServerError.is(error) || ServerParseError.is(error)) {
      const networkError = error;
      // È presente un errore di rete, lo gestiamo ignorando gli errori GraphQL
      logger.error(`Network error: ${networkError.message} `, networkError);

      const appErrorBuilder = new AppErrorBuilder(networkError.message)
        .addCause(networkError)
        .addInfo('operationName', operation.operationName ?? '');

      appErrorBuilder.addInfo('operationVariables', safeStringify(operation.variables));

      errorService.logError(appErrorBuilder.build());
      return;
    }
  });
}
